import { xmSessionStorage } from '@xmatters/common/utils/xmStorage';

import persistState from './creators/persistState';

export default persistState({
  key: 'helpView',
  slicer: state => ({
    helpPopover: {
      isOpen: state.helpPopover?.isOpen,
      currentTab: state.helpPopover?.currentTab,
    },
  }),
  storage: xmSessionStorage,
});
